import $ from 'jquery'
// import Swiper JS
import Swiper from 'swiper';


export default class JournalSwiper {
  constructor(props) {
    this.swipers = document.querySelector(props.target)
  }

  init() {
    if(this.swipers) {
      const swiper = new Swiper('.js-journal-swiper', {
        loop: true,
        observer: true,
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 40,
        speed: 1000,
        updateOnWindowResize: true,
        paginationClickable: true,
        autoResize: true,
        autoplay: {
          delay: 6000,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.c-journal-slider-btn-next',
          prevEl: '.c-journal-slider-btn-prev',
        },

        breakpoints: {
          // when window width is >= 320px
          375: {
            slidesPerView: 1,
            updateOnWindowResize: true,
          },
        }
      })

      swiper.on('click', function () {
        // console.log(this.clickedSlide);
        $('swiper-navigation-color .swiper-slide').removeClass('swiper-slide-active')
        $(this.clickedSlide).addClass('swiper-slide-active')

        const slideToIndex = $(this.clickedSlide).data('swiper-slide-index')
        swiper.slideToLoop(slideToIndex)
        swiper.update()
      })

      window.addEventListener("resize", function() {
        swiper.updateSize()
      })

      // $('.swiper-slide-prev').on('click', (e) => {
      //   e.preventDefault()
      //   swiper.swipePrev()
      // })

      // $('.swiper-slide-next').on('click', (e) => {
      //   e.preventDefault()
      //   swiper.swipeNext()
      // })
    }
  }
}
